import React, { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { BaseFormViewComponentProps, FormHandles } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { LoginFormTypes } from "models/formTypes";
import { InputProps } from "models/propTypes/wintFormPropsTypes";
//#endregion
//#region components
import { EmailInput, useWintForm, VerticalFormField, WintForm } from "components/common/wintForms";
//#endregion

const ForgotPasswordForm: ForwardRefRenderFunction<FormHandles, BaseFormViewComponentProps> = (props, ref) => {
  const { wintFormProps, connect } = useWintForm<LoginFormTypes.ForgotPassword>({
    formRef: ref,
    ...props,
    validateOnBlur: true,
    validateOnChange: false,
    validateOnMount: false,
  });

  return (
    <WintForm {...wintFormProps}>
      <VerticalFormField<InputProps>
        Component={EmailInput}
        {...connect("userName")}
        label={TranslationKeys.Login.Email}
        icon={IconDefinitionConstants.WUser}
      />
    </WintForm>
  );
};

export default forwardRef(ForgotPasswordForm);
